
import { Link } from 'react-router-dom'
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';


const Home = () => {

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [title, setTitle] = useState('')
  const [body, setBody] = useState('')
const [loading, setLoading] = useState(false);

const [showImageModal, setShowImageModal] = useState(false);
const [imgTitle, setImgTitle] = useState('');
const [imgBody, setImgBody] = useState('');
const [imgFile, setImgFile] = useState(null);

// const handleCloseImageModal = () => setShowImageModal(false);
const handleCloseImageModal = () => {
  setShowImageModal(false);
  setImgTitle('');
  setImgBody('');
  setImgFile(null);
};
const handleShowImageModal = () => setShowImageModal(true);


// const run = () => {
//   const dist = sessionStorage.getItem("dist");

//   axios.post("https://lionsdirectoryapi.emedha.in/notification/api/run/get", {
//     title,
//     body,
//     dist,  // added district value
//   }).then((res) => {
//     if (res.data === 'ok') {
//       alert('Notification Successfully sent');
//       handleClose();
//     }
//   });
// };


// Consolidated function handling both text and image notifications
const run = () => {
  const dist = sessionStorage.getItem("dist");

  if (!title || !body) {
    alert("Please fill in both title and body.");
    return;
  }

  const formData = new FormData();
  formData.append('title', title);
  formData.append('body', body);
  formData.append('dist', dist);

  // If user selected an image in Modal 1
  if (imgFile) {
    formData.append('image', imgFile);
  }

  axios.post("https://lionsdirectoryapi.emedha.in/notification/api/run/get", formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then((res) => {
    if (res.data === 'ok') {
      alert('Notification successfully sent');
      handleClose();
      setTitle('');
      setBody('');
      setImgFile(null);
    }
  }).catch((err) => {
    console.error('Notification send error:', err);
    alert('Failed to send notification');
  });
};

const runWithImage = () => {
  const dist = sessionStorage.getItem("dist");

  if (!imgTitle || !imgBody) {
    alert("Please fill in both title and body.");
    return;
  }

  setLoading(true); // ✅ Disable button and show loader

  const formData = new FormData();
  formData.append('title', imgTitle);
  formData.append('body', imgBody);
  formData.append('dist', dist);
  
  if (imgFile) {
    formData.append('image', imgFile);
  }

  axios.post("https://lionsdirectoryapi.emedha.in/notification/api/run-with-image", formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then((res) => {
    if (res.status === 200 || res.data.sentCount !== undefined || res.data === 'ok') {
      alert(`Notification sent successfully! (Targeted: ${res.data.sentCount ?? 0})`);
      
      handleCloseImageModal();
      setImgTitle('');
      setImgBody('');
      setImgFile(null);
    }
  }).catch((err) => {
    console.error('Notification send error:', err);
    alert('Failed to send notification');
  }).finally(() => {
    setLoading(false); // ✅ Re-enable button after response
  });
};
  // return (
  //   <div className='mt-5 pb-5 pt-5'>
  //     <button onClick={handleShow} style={{ color: 'white', borderRadius: "0.6rem",height:'2.6rem',width:'10rem',border:'none',backgroundColor:'orange', fontWeight: 'bold',marginBottom:'0.9rem' }}>Send Notification</button>
  //     <div className='text-center container d-block d-md-flex justify-content-between btnContainer '>
  //       <div>
  //       <Link to='/chairperson-users'><button className='btnStyle shadow'><strong>Chairperson Logins</strong></button></Link>
  //       <br />
  //         <br />
  //         <br />
      
       
         
          
  //         <Link to='/view-club'><button className='btnStyle shadow'><strong> Club</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
  //         <Link to='/view-member'> <button className='shadow  btnStyle'><strong>  Members</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
  //         <Link to='/notification-message'> <button className='shadow  btnStyle'><strong>Notification Message</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
        
  //       </div>
  //       <br />
  //       <br />
  //       <br />
  //       <div>
  //       <Link to='/register-users'><button className='btnStyle shadow'><strong> Register Users</strong></button></Link>
  //       <br />
  //         <br />
  //         <br />
  //         <Link to='/view-events'><button className='shadow  btnStyle'><strong>  Events</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
  //         <Link to='/view-project'> <button className='shadow  btnStyle'><strong>  Project</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
  //         <Link to='/view-cabinet'><button className='shadow  btnStyle'><strong>Cabinet Master</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
        
  //       </div>
  //       <br />
  //       <br />
  //       <br />
  //       <div>
  //         <Link to='/multiple'> <button className='shadow  btnStyle'><strong>Multiple</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
  //         <Link to='/international'> <button className='shadow  btnStyle'><strong>International</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
  //         <Link to='/advertisement'> <button className='shadow  btnStyle'><strong>Advertisement</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
  //         <Link to='/gallery'> <button className='shadow  btnStyle'><strong>Gallery</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
        
  //       </div>
  //       <br />
  //       <br />
  //       <br />
  //       <div>
  //         <Link to='/menu'> <button className='shadow  btnStyle'><strong>Menu</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
  //         <Link to='/dollar'> <button className='shadow  btnStyle'><strong>Dollar</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
  //         <Link to='/DG-Diary'> <button className='shadow  btnStyle'><strong>DG-Diary</strong></button></Link>
  //         <br />
  //         <br />
  //         <br />
        
         
  //       </div>
  //       <br />
  //       <br />
  //       <br />
  //     </div>

  //     <>
  //       <Modal show={show} onHide={handleClose} size='sm' centered>
  //         <Modal.Header closeButton>
  //           <Modal.Title>Send Notification</Modal.Title>
  //         </Modal.Header>
  //         <Modal.Body>
  //           <input style={{backgroundColor:'white',height:'2.6rem',width:'100%',borderRadius:'0.5rem',marginBottom:10,outlineColor:'orange'}} type="text" className='inputText' placeholder='Enter notification title' onChange={(e) => setTitle(e.target.value)} />
  //           <input style={{backgroundColor:'white',height:'2.6rem',width:'100%',borderRadius:'0.5rem',marginBottom:10,outlineColor:'orange'}} type="text" className='inputText' placeholder='Enter notification Body' onChange={(e) => setBody(e.target.value)} />
  //           <button onClick={() => run()} className='notificationButton' style={{ marginTop: "0.4rem",height:'2.6rem',width:'5rem',borderRadius:'0.5rem',backgroundColor:'orange',border:'none',fontWeight:'bold',color:'white'}}>Send</button>
  //         </Modal.Body>
  //         <Modal.Footer>
  //         </Modal.Footer>
  //       </Modal>
  //     </>
  //   </div>
  // )

  const userType = sessionStorage.getItem("usertype");

  const role = sessionStorage.getItem("role");


return (
  <div className="mt-4 pb-5 pt-5">
  {role !== "superAdmin" && role !== "clubAdmin" &&(
      <button
        onClick={handleShow}
        style={{
          color: "white",
          borderRadius: "0.6rem",
          height: "2.6rem",
          width: "13rem",
          border: "none",
          backgroundColor: "orange",
          fontWeight: "bold",
          marginBottom: "0.9rem",
        }}
      >
        Send Notification iOS
      </button>)}
     

{role !== "superAdmin" && role !== "clubAdmin" && (
  <button
    onClick={handleShowImageModal}
    style={{
      color: "white",
      borderRadius: "0.6rem",
      height: "2.6rem",
      width: "18rem",
      border: "none",
      backgroundColor: "orange",
      fontWeight: "bold",
      marginBottom: "0.9rem",
      marginLeft: '20px'
    }}
  >
    Send Notification Android
  </button>
)}

   {role !== "superAdmin" && role !== "clubAdmin" &&(
<Link to="/home" className='btn btn-warning' style={{marginLeft:'20px', fontWeight:'bold'}}>
  Open App Preview
</Link>)}

    <div className="text-center container d-block d-md-flex justify-content-between btnContainer">

        <>


            {role === "superAdmin" ? (
              <>
<div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
  <div>
    <Link to="/district-approval">
      <button className="shadow btnStyle">
        <strong>District Approval</strong>
      </button>
    </Link>
     <br />
            <br />
            <br />

  </div>

  <div>
    <Link to="/distirct">
      <button className="btnStyle shadow">
        <strong>District</strong>
      </button>
    </Link>
  </div>

    <div>
    <Link to="/club-logs">
      <button className="btnStyle shadow">
        <strong>Club Master Logs</strong>
      </button>
    </Link>
  </div>

    <div>
    <Link to="/member-logs">
      <button className="btnStyle shadow">
        <strong>Member Master Logs</strong>
      </button>
    </Link>
  </div>

    <div>
    <Link to="/cabinet-logs">
      <button className="btnStyle shadow">
        <strong>Cabinet Master Logs</strong>
      </button>
    </Link>
  </div>
</div>

  </>
  
):
role === "clubAdmin" ? (
    /* ✅ New UI layout segment for logged-in Club Officials */
    <>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
        <div>
          <Link to="/club-members">
            <button className="shadow btnStyle">
              <strong>Club Members</strong>
            </button>
          </Link>
          <br /><br /><br />
        </div>
      </div>
    </>



):(

<>
          <div>
          <Link to="/register-users">
              <button className="btnStyle shadow">
                <strong>Register Users</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />

            <Link to="/view-club">
              <button className="btnStyle shadow">
                <strong>Club</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />
            <Link to="/view-member">
              <button className="shadow btnStyle">
                <strong>Members</strong>
              </button>
            </Link> 
            <br />
            <br />
            <br />
            <Link to="/notification-message">
              <button className="shadow btnStyle">
                <strong>Notification Message iOS</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />
            <Link to="/Contactt">
              <button className="shadow btnStyle">
                <strong>Contact</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />
            <Link to="/address-book">
              <button className="shadow btnStyle">
                <strong>Address Book</strong>
              </button>
            </Link>
           
           
          </div>

          <div>
          <Link to="/advertisement">
              <button className="shadow btnStyle">
                <strong>Advertisement</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />
            <Link to="/view-events">
              <button className="shadow btnStyle">
                <strong>Events</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />
            <Link to="/view-project">
              <button className="shadow btnStyle">
                <strong>Project</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />
             <Link to="/notification-android">
              <button className="shadow btnStyle">
                <strong>Notifications Message Android</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />
            <Link to="/view-cabinet">
              <button className="shadow btnStyle">
                <strong>Cabinet Master</strong>
              </button>
            </Link>


          <br />
            <br />
            <br />
           

      
              <Link to="/download-master">
              <button className="shadow btnStyle">
                <strong>Upload Master</strong>
              </button>
            </Link>
             
             <br />
            <br />
            <br />
             {sessionStorage.getItem("dist")==='320G' &&
             <Link to="/contest-rule">
              <button className="shadow btnStyle">
                <strong>Contest Rules</strong>
              </button>
            </Link>} 

            </div>

          <div>
            <Link to="/menus-advertisement">
              <button className="shadow btnStyle">
                <strong>Menus Advertisement</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />
            <Link to="/multiple">
              <button className="shadow btnStyle">
                <strong>Multiple</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />
        
            
            <Link to="/meetings">
            <button className="shadow btnStyle">
              <strong>Meetings</strong>
            </button>
          </Link>
          <br />
            <br />
            <br />
            <Link to="/international">
              <button className="shadow btnStyle">
                <strong>International</strong>
              </button>
            </Link>

            <br />
            <br />
            <br />
            <Link to="/cabinet">
              <button className="shadow btnStyle">
                <strong>Cabinet</strong>
              </button>
            </Link>


          <br />
            <br />
            <br />
           
     
           
          </div>

          <div>
            <Link to="/menu">
              <button className="shadow btnStyle">
                <strong>Menu</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />
            <Link to="/dollar">
              <button className="shadow btnStyle">
                <strong>Dollar</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />
            <Link to="/DG-Diary">
              <button className="shadow btnStyle">
                <strong>DG-Diary</strong>
              </button>
            </Link>
            <br />
            <br />
            <br />
            <Link to="/galleryy">
              <button className="shadow btnStyle">
                <strong>Gallery</strong>
              </button>
            </Link>
   <br />
            <br />
            <br />

             <Link to="/downloads">
              <button className="shadow btnStyle">
                <strong>Uploads</strong>
              </button>
            </Link>
           
          </div>
          
            </>
    )}
  </>
</div>


      <Modal show={show} onHide={handleClose} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Send Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            style={{
              backgroundColor: "white",
              height: "2.6rem",
              width: "100%",
              borderRadius: "0.5rem",
              marginBottom: 10,
              outlineColor: "orange",
            }}
            type="text"
            className="inputText"
            placeholder="Enter notification title"
            onChange={(e) => setTitle(e.target.value)}
          />
          <input
            style={{
              backgroundColor: "white",
              height: "2.6rem",
              width: "100%",
              borderRadius: "0.5rem",
              marginBottom: 10,
              outlineColor: "orange",
            }}
            type="text"
            className="inputText"
            placeholder="Enter notification Body"
            onChange={(e) => setBody(e.target.value)}
          />

           <input
      style={{
        backgroundColor: "white",
        width: "100%",
        marginBottom: 10,
      }}
      type="file"
      accept="image/*"
      className="form-control"
      onChange={(e) => {
        if (e.target.files && e.target.files[0]) {
          setImgFile(e.target.files[0]);
        }
      }}
    />

    {/* ✅ IMAGE PREVIEW CONTAINER */}
       {imgFile && (
      <div className="text-center my-3 p-2 border rounded bg-light position-relative">
        <p className="fw-semibold text-secondary mb-1" style={{ fontSize: "12px" }}>
          Selected Image Preview:
        </p>
        <img
          src={URL.createObjectURL(imgFile)}
          alt="Notification Preview"
          style={{
            maxHeight: "180px",
            maxWidth: "100%",
            objectFit: "contain",
            borderRadius: "8px",
            border: "1px solid #ddd",
          }}
        />
        <div className="mt-2">
          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            onClick={() => setImgFile(null)}
            style={{ fontSize: "12px" }}
          >
            Remove Image
          </button>
        </div>
      </div>
    )}
          <button
            onClick={() => run()}
            className="notificationButton"
            style={{
              marginTop: "0.4rem",
              height: "2.6rem",
              width: "5rem",
              borderRadius: "0.5rem",
              backgroundColor: "orange",
              border: "none",
              fontWeight: "bold",
              color: "white",
            }}
          >
            Send
          </button>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      {/* Modal for Notification With Image */}
<Modal show={showImageModal} onHide={handleCloseImageModal} size="md" centered>
  <Modal.Header closeButton>
    <Modal.Title>Notification With Image</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <input
      style={{
        backgroundColor: "white",
        height: "2.6rem",
        width: "100%",
        borderRadius: "0.5rem",
        marginBottom: 10,
        outlineColor: "orange",
      }}
      type="text"
      className="inputText form-control"
      placeholder="Notification title"
      onChange={(e) => setImgTitle(e.target.value)}
    />
    <textarea
      style={{
        backgroundColor: "white",
        width: "100%",
        borderRadius: "0.5rem",
        marginBottom: 10,
        outlineColor: "orange",
      }}
      rows={3}
      className="inputText form-control"
      placeholder="Notification Body"
      onChange={(e) => setImgBody(e.target.value)}
    />
    
    <input
      style={{
        backgroundColor: "white",
        width: "100%",
        marginBottom: 10,
      }}
      type="file"
      accept="image/*"
      className="form-control"
      onChange={(e) => {
        if (e.target.files && e.target.files[0]) {
          setImgFile(e.target.files[0]);
        }
      }}
    />

    {/* ✅ IMAGE PREVIEW CONTAINER */}
    {imgFile && (
      <div className="text-center my-3 p-2 border rounded bg-light position-relative">
        <p className="fw-semibold text-secondary mb-1" style={{ fontSize: "12px" }}>
          Selected Image Preview:
        </p>
        <img
          src={URL.createObjectURL(imgFile)}
          alt="Notification Preview"
          style={{
            maxHeight: "180px",
            maxWidth: "100%",
            objectFit: "contain",
            borderRadius: "8px",
            border: "1px solid #ddd",
          }}
        />
        <div className="mt-2">
          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            onClick={() => setImgFile(null)}
            style={{ fontSize: "12px" }}
          >
            Remove Image
          </button>
        </div>
      </div>
    )}

  <button
  onClick={runWithImage}
  disabled={loading}
  className="notificationButton btn w-100 mt-2 d-flex align-items-center justify-content-center"
  style={{
    height: "2.6rem",
    borderRadius: "0.5rem",
    backgroundColor: loading ? "#ccc" : "orange",
    border: "none",
    fontWeight: "bold",
    color: "white",
    cursor: loading ? "not-allowed" : "pointer",
  }}
>
  {loading ? (
    <>
      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Sending...
    </>
  ) : (
    "Send Notification"
  )}
</button>
  </Modal.Body>
</Modal>

  </div>
);

}

export default Home

